const friendLink = {
    path: '/website/friendLink',
    component: resolve => require(['@/views/website/friendLink'], resolve),
    name: 'friendLink',
    meta: {title: '友情链接'}
};

const propose = {
    path: '/website/propose',
    component: resolve => require(['@/views/website/propose'], resolve),
    name: 'propose',
    meta: {title: '建议留言'}
};

const purpose = {
    path: '/website/purpose',
    component: resolve => require(['@/views/website/purpose'], resolve),
    name: 'purpose',
    meta: {title: '意向代理'}
};

export default [friendLink,propose,purpose]





// WEBPACK FOOTER //
// ./src/router/modules/website.js